import { useEffect, useState } from "react"

import { Flex } from "antd"
import { useSelector } from "react-redux"

import ExportDropdown from "../../../../Components/Export"
import ListViewToggle from "../../../../Components/ListViewToggle/ListViewToggle"
import ManageColumn from "../../../../Components/ManageColumns"
import { useExternalDemoMode } from "../../../../hooks/useExternalDemoMode"
import { selectAreFiltersDefault } from "../../redux/receipt.slice"
import FilterBar from "../FilterBar"
import { ReceiptLookupList } from "../ReceiptLookupList"
import ReceiptLookupTable from "../ReceiptLookupTable"
import { receiptColumnIconMap } from "../ReceiptLookupTable/columns.jsx"

const PAGE_SIZE = 20

export const ReceiptLookup = ({
  isMobile,
  isDemo,
  isAdminPage,
  canExport,
  onChangeFilter,
  onClearFilters,
  onChangeColumns,
  onChangeViewMode,
  onExport,
  onGetLookups
}) => {
  const [page, setPage] = useState(1)
  const [ordering, setOrdering] = useState(null)
  const externalDemoMode = useExternalDemoMode()

  const demoDisabled = isDemo || externalDemoMode

  const {
    fetching,
    exportFetching,
    result,
    filters,
    visibleFilters,
    columns,
    viewMode,
    selectedProgram
  } = useSelector((s) => s.receipt)

  const isFiltersDefault = useSelector(selectAreFiltersDefault)

  const effectiveViewMode = isMobile ? "cards" : viewMode

  useEffect(() => {
    setPage(1)
  }, [filters, selectedProgram])

  useEffect(() => {
    onGetLookups({ page, ordering, page_size: PAGE_SIZE })
  }, [onGetLookups, page, ordering])

  return (
    <>
      {/* §BLOCK 4.2 — filter bar + Export */}
      <FilterBar
        visibleFilters={visibleFilters}
        filters={filters}
        onChangeFilter={onChangeFilter}
        onClearFilters={onClearFilters}
        isFiltersDefault={isFiltersDefault}
        isMobile={isMobile}
        rightSlot={
          <Flex gap={8} align="center">
            {canExport && (
              <ExportDropdown
                loading={exportFetching}
                onExport={onExport}
                isAdmin={isAdminPage}
                disabled={demoDisabled}
                iconButton={isMobile}
              />
            )}

            {!isMobile && (
              <ManageColumn
                myColumns={columns}
                onChangeColumns={onChangeColumns}
                pinnedColumns={[]}
                iconMap={receiptColumnIconMap}
              />
            )}
            {!isMobile && (
              <span data-testid="deflect-user-view-toggle">
                <ListViewToggle view={viewMode} setView={onChangeViewMode} />
              </span>
            )}
          </Flex>
        }
      />

      {/* §BLOCK 4 */}
      {effectiveViewMode === "cards" ? (
        <ReceiptLookupList
          loading={fetching}
          data={result?.results}
          totalCount={result?.count || 0}
          page={page}
          pageSize={PAGE_SIZE}
          onChangePage={setPage}
        />
      ) : (
        <ReceiptLookupTable
          loading={fetching}
          data={result?.results}
          totalCount={result?.count || 0}
          page={page}
          pageSize={PAGE_SIZE}
          columns={columns}
          onChangeOrdering={setOrdering}
          onChangePage={setPage}
        />
      )}
    </>
  )
}
